module.exports = __webpack_public_path__ + "img/kDokY1N.6d07544b.png";